import React, { useEffect, useState } from "react";
import { api, fmtDate } from "../lib/api";
import { PageHeader, Panel } from "../lib/ui";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

const TYPES = ["Opening", "Receiving", "QC Passed", "QC Rework", "QC Reject",
  "Warehouse Transfer Out", "Warehouse Transfer In", "Adjustment", "POS Import"];

export default function StockMovement() {
  const [rows, setRows] = useState([]);
  const [type, setType] = useState("all");

  const load = () => api.get("/stock/movements", { params: type !== "all" ? { movement_type: type } : {} }).then((r) => setRows(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [type]);

  return (
    <div data-testid="movements-page">
      <PageHeader title="Stock Movement" subtitle="Ledger semua perubahan stok (tidak dapat diedit langsung)">
        <Select value={type} onValueChange={setType}>
          <SelectTrigger className="w-56 bg-white" data-testid="movement-type-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Semua Tipe</SelectItem>
            {TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
          </SelectContent>
        </Select>
      </PageHeader>

      <Panel>
        <Table>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead>Waktu</TableHead>
              <TableHead>Tipe</TableHead>
              <TableHead>Produk</TableHead>
              <TableHead>Referensi</TableHead>
              <TableHead className="text-right">Sebelum</TableHead>
              <TableHead className="text-right">Perubahan</TableHead>
              <TableHead className="text-right">Sesudah</TableHead>
              <TableHead>Pengguna</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((m) => (
              <TableRow key={m.id}>
                <TableCell className="text-xs text-wmuted whitespace-nowrap">{fmtDate(m.datetime)}</TableCell>
                <TableCell className="text-sm font-medium text-cocoa">{m.movement_type}</TableCell>
                <TableCell className="text-sm">{m.product_name} <span className="text-wmuted">{m.color}/{m.size}</span></TableCell>
                <TableCell className="font-mono text-xs">{m.reference}</TableCell>
                <TableCell className="text-right">{m.qty_before}</TableCell>
                <TableCell className={`text-right font-bold ${m.qty_change >= 0 ? "text-status-passed" : "text-status-reject"}`}>
                  {m.qty_change >= 0 ? "+" : ""}{m.qty_change}
                </TableCell>
                <TableCell className="text-right font-semibold text-cocoa">{m.qty_after}</TableCell>
                <TableCell className="text-xs">{m.user_name}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={8} className="text-center text-wmuted py-10">Belum ada pergerakan stok.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Panel>
    </div>
  );
}
